/**
 * Utility functions for active photo/image display filtering.
 *
 * `active` boolean field indicates whether an individual photo in a property
 * or website library is enabled for public display on the website (active: true)
 * or hidden/stored in library (active: false).
 */

export const isActivePhoto = (photo) => {
  return Boolean(photo && photo.active !== false);
};

export const filterActivePhotos = (photos) => {
  if (!Array.isArray(photos)) return [];
  return photos.filter(isActivePhoto);
};

export const filterActiveImages = (images) => {
  if (!images || typeof images !== 'object') return images;
  const filtered = {};
  for (const [key, val] of Object.entries(images)) {
    if (Array.isArray(val)) {
      filtered[key] = val.filter(isActivePhoto);
    } else {
      filtered[key] = val;
    }
  }
  return filtered;
};

export const filterActiveDestination = (destination) => {
  if (!destination) return destination;
  return {
    ...destination,
    images: filterActiveImages(destination.images),
  };
};

export const filterActiveProperty = (property) => {
  if (!property) return property;
  return {
    ...property,
    photos: filterActivePhotos(property.photos),
  };
};

export const filterActiveSafari = (safari) => {
  if (!safari) return safari;
  return {
    ...safari,
    photos: filterActivePhotos(safari.photos),
  };
};
